import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { LayoutPublic } from '../../../layout/public';
import FieldText from '../../../components/general/fields/fieldText';
import { Dialog } from '../../../components/general/dialog/dialog';

import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { UsersMessages } from '../../../../shared/messages/usersMessages';

import { useUpdatePassword } from './hook';

export const UpdatePasswordUser = () => {
    const {
        formik,
        loading,
        handleClickSend,
        sendCode,
        formikValidationCode,
        validationCode,
        isForwardDisabled,
        timeLeftForward,
        setShowPasswordRestrictionModal,
        showPasswordRestrictionModal,
        userEmailForModal,
    } = useUpdatePassword();

    const { usersMessages }: any = UsersMessages;

    const renderTimeLeftMessage = (timeLeftForward: any) => {
        if (timeLeftForward <= 0) return null;
        let mensaje = `El código se podrá reenviar en `;
        mensaje +=
            timeLeftForward >= 60
                ? ` ${Math.floor(timeLeftForward / 60)}:${
                    timeLeftForward % 60 < 10 ? '0' : ''
                }${timeLeftForward % 60} minutos`
                : ` ${timeLeftForward} segundos`;

        return (
            <Grid item xs={12}>
                <Typography style={{ color: 'grey' }} variant="subtitle2">
                    {mensaje}
                </Typography>
            </Grid>
        );
    };

    return (
        <>
            <LayoutPublic title="Actualización de contraseña" />
            <Grid
                container
                item
                xs={12}
                mt={8}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '50vh' }}
            >
                <Box
                    style={{
                        maxWidth: '400px',
                        textAlign: 'center',
                        padding: '16px',
                    }}
                >
                    <Typography variant="h6" style={{ marginBottom: '16px' }}>
                        Ingresa el correo con el que inicias sesión. Te
                        enviaremos un código de verificación para actualizar tu
                        contraseña.
                    </Typography>
                    <Box component="form" noValidate sx={{ mt: 1 }}>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12}>
                                <FieldText
                                    label="Correo"
                                    name="email"
                                    required={true}
                                    size="small"
                                    autoComplete="email"
                                    disabled={sendCode}
                                    touched={formik.touched.email}
                                    errors={formik.errors.email}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            {sendCode && (
                                <Grid item xs={12}>
                                    <FieldText
                                        label="Código de verificación"
                                        name="code"
                                        size="small"
                                        required={true}
                                        disabled={validationCode}
                                        touched={
                                            formikValidationCode.touched.code
                                        }
                                        errors={
                                            formikValidationCode.errors.code
                                        }
                                        value={formikValidationCode.values.code}
                                        onChange={
                                            formikValidationCode.handleChange
                                        }
                                    />
                                </Grid>
                            )}
                            {validationCode && (
                                <>
                                    <Grid item xs={12}>
                                        <FieldText
                                            label="Nueva Contraseña"
                                            name="password"
                                            type="password"
                                            size="small"
                                            required={true}
                                            touched={formik.touched.password}
                                            errors={formik.errors.password}
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FieldText
                                            label="Confirmar Contraseña"
                                            name="password_retry"
                                            type="password"
                                            size="small"
                                            required={true}
                                            touched={
                                                formik.touched.password_retry
                                            }
                                            errors={
                                                formik.errors.password_retry
                                            }
                                            value={formik.values.password_retry}
                                            onChange={formik.handleChange}
                                        />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12}>
                                {!validationCode && (
                                    <LoadingButtonGeneral
                                        onClick={handleClickSend}
                                        title={
                                            sendCode
                                                ? 'Reenviar Código'
                                                : 'Enviar Código'
                                        }
                                        disabled={isForwardDisabled}
                                        loading={loading}
                                        sx={{ mr: 1 }}
                                    />
                                )}
                                {sendCode && (
                                    <LoadingButtonGeneral
                                        onClick={
                                            validationCode
                                                ? formik.handleSubmit
                                                : formikValidationCode.handleSubmit
                                        }
                                        title={
                                            validationCode
                                                ? 'Guardar'
                                                : 'Validar Código'
                                        }
                                        loading={loading}
                                        sx={{ mr: 1 }}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                {!validationCode &&
                                    timeLeftForward > 0 &&
                                    renderTimeLeftMessage(timeLeftForward)}
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Grid>
            <Dialog
                title="Actualización de contraseña no disponible"
                open={showPasswordRestrictionModal}
                onClose={() => setShowPasswordRestrictionModal(false)}
            >
                <Grid
                    container
                    item
                    xs={12}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            maxWidth: '500px',
                            textAlign: 'left',
                            padding: '16px',
                        }}
                    >
                        <Typography variant="body1" paragraph>
                            Lo sentimos,{' '}
                            {usersMessages.PASSWORD_UPDATE_FORBIDDEN}
                        </Typography>

                        <Box
                            style={{
                                background: '#f8f9fa',
                                padding: '12px',
                                borderRadius: '8px',
                                marginTop: '8px',
                                marginBottom: '16px',
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                style={{ marginBottom: '6px', fontWeight: 500 }}
                            >
                                Por favor:
                                <ol
                                    style={{
                                        marginTop: 0,
                                        paddingLeft: '20px',
                                    }}
                                >
                                    <li style={{ marginBottom: '6px' }}>
                                        Contacta al administrador del sistema
                                    </li>
                                    <li style={{ marginBottom: '6px' }}>
                                        Solicita que habiliten la actualización
                                        de contraseña
                                    </li>
                                    <li>
                                        Proporciona tu correo registrado:{' '}
                                        <strong>{userEmailForModal}</strong>
                                    </li>
                                </ol>
                            </Typography>
                        </Box>

                        <Box
                            style={{
                                padding: '8px',
                                background: '#fff3cd',
                                borderRadius: '4px',
                                borderLeft: '4px solid #ffc107',
                            }}
                        >
                            <Typography variant="body2">
                                <strong>Recuerda:</strong> Debes tener acceso a
                                este correo, ya que se enviará un código de
                                verificación.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Dialog>
        </>
    );
};
